export default function JOIN( value, separator ) {
  if ( ! value ) return null

  if ( value instanceof Array === false ) return value

  return value.join( separator )
}
